var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStopDelivery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    className: "icon-fill",
    fill: "#7A7A7A",
    d: "M12.445.23v7.11l3.464.001c.355 0 .556.388.382.673l-.047.064-5.243 5.992c-.177.203-.492.203-.669 0L5.089 8.078c-.251-.287-.047-.737.335-.737H8.89V.23h3.556z",
    transform: "translate(1.333 2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon-stroke",
    stroke: "#7A7A7A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.444 14.222L0 16 10.667 19.556 21.333 16 16.889 14.222",
    transform: "translate(1.333 2)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopDelivery);
export default __webpack_public_path__ + "static/media/stop-delivery.f9eee95c.svg";
export { ForwardRef as ReactComponent };